import { useState } from 'react'
import {
  updateWorkOrderPriorityDown,
  updateWorkOrderPriorityUp,
  updateWorkOrderTopPriority
} from '../config/api'
import { AxiosResponse } from 'axios'
import { useApi } from '../../../hooks/useApi'
import { Filter } from '../../../components/_WMS/FilterComponent'

// Tipos e interfaces
type PriorityActionType = 'top' | 'up' | 'down'

interface Pagination {
  page: number
  pageSize: number
}

// Implementación del hook usePriorityManagement
export function usePriorityManagement() {
  const [isPriorizing, setIsPriorizing] = useState<boolean>(false)
  const { callApi, state: updatePriorityState } = useApi() // Reemplaza `any` con el tipo específico de respuesta de tu API

  const requestUpdatePriority = (
    actionType: PriorityActionType,
    workOrderId: number,
    pagination: Pagination,
    selectedFilters: Filter[]
  ) => {
    let apiFunction: Promise<AxiosResponse<any>> // Reemplaza `any` con el tipo específico de tu respuesta API

    switch (actionType) {
      case 'top':
        apiFunction = updateWorkOrderTopPriority(
          workOrderId,
          pagination.page,
          pagination.pageSize,
          selectedFilters
        )
        break
      case 'up':
        apiFunction = updateWorkOrderPriorityUp(
          workOrderId,
          pagination.page,
          pagination.pageSize,
          selectedFilters
        )
        break
      case 'down':
        apiFunction = updateWorkOrderPriorityDown(
          workOrderId,
          pagination.page,
          pagination.pageSize,
          selectedFilters
        )
        break
      default:
        throw new Error('ActionType no válido')
    }

    return callApi(apiFunction)
  }

  return {
    isPriorizing,
    setIsPriorizing,
    requestUpdatePriority,
    state: updatePriorityState
  }
}
